import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import logo from '../assets/images/logo.svg';

const Header = () => {
  const { keycloak } = useKeycloak();

  const startLogout = () => {
    keycloak.logout();
  }

  return (
  <header className="p-3" style={{backgroundColor:'#0071CE', fontSize:'15px'}}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-6">
            <a href={(!keycloak.authenticated ? '/' : '/dashboard')}><img src={logo} /></a>
          </div>
          <div className="col-6">
            <div className="nav justify-content-end">
              {!keycloak.authenticated && (
                <a className="nav-item nav-link text-white" href="https://www.cgd.pt/Site/CXA/CGD-Pensoes/Pages/CGD-Pensoes.aspx" target="_blank" rel="noopener noreferrer">Voltar a CGD Pensões</a>
              )}
              {!!keycloak.authenticated && (
                <a className="nav-item nav-link text-white" href="#" onClick={() =>  startLogout()}>Terminar sessão</a>
              )}
            </div>
          </div>
        </div>
      </div>
  </header>
 );
};

export default Header;
